import { ApolloQuery, html } from '@apollo-elements/lit-apollo';
import { css } from 'emotion';
import Search from './search.graphql';

export class PageSearch extends ApolloQuery {
  query = Search;
  variables = {
    "keyword": ``,
  };

  createRenderRoot() {
    return this;
  }
  
  render() {
    return html`
      <div class="${this.basicStyles}">
        <!-- TODO: 휴게소 검색 결과 -->
        <!-- TODO: 지역 검색 결과 -->

        <!-- TODO: 아무것도 입력하지 않았을 경우 -->
        <!-- TODO: 최근 검색할 기록이 있는 경우 -->
        <input class="search" type="text" placeholder="지역/휴게소 검색" value=""
          @keyup=${this.search}
        />
        <div class="search-content">
          <div class="search-content__top-bar">
            <!-- <span class="top-bar__search-result">검색 결과</span>
            <span class="top-bar__sort">
              <button class="sort-street-button active">거리순</button>
            </span> -->
          </div>

          ${this.data.search.restAreas === null && this.data.search.zones === null
          ? html`
          <div class="no-result">검색 결과가 없습니다.</div>
          `
          
          :html`
          ${this.searchResultTemplate({
            category: `REST_AREA`,
            total: this.data?.search?.restAreas?.length || 0,
            searchList: this.data?.search?.restAreas?.map(each => {
              return {
                name: `${each.name}(${each.direction || ``})`,
                id: each.id,
              }
            }) || [],
          })}

          ${this.searchResultTemplate({
            type: `REGION`,
            total: this.data?.search?.zones?.length || 0,
            searchList: this.data?.search?.zones?.map(each => {
              return {
                name: `${each.name}`,
                id: each.id,
              }
            }) || [],
          })}
          `}          
        </div>
      </div>
    `;
  }

  async search(event) {
    const { target } = event;
    const value = target.value;

    if (!value.trim()) {
      return;
    }

    await this.refetch({
      keyword: value,
    });
  }

  searchResultTemplate(data = {
    category: `REST_AREA` || `REGION`,
    total: 0,
    searchList: [],
  }) {    
    return html`
    <div class="wrap ${this.searchResultStyle()} ${data.category === `REST_AREA` ? `wrap__rest` : `wrap__region`}">
      <h2>${data.category === `REST_AREA` ? `휴게소` : `지역`} ${data.total}건</h2>

      <ul class="result-list">
        ${data.searchList.map(list => html`
        <li>
          <a href="/${data.category === `REST_AREA` ? `rest-area` : `region`}/${list.id}">${list.name}</a>
        </li>
        `)}
      </ul>      
    </div>
    `;
  }

  searchResultStyle() {
    return css`
    & {
      padding-left: 25px;
      padding-right: 10px;
      padding-bottom: 20px;
      border-bottom: 1px solid #333a;
      max-height: 150px;
      overflow-y: scroll;
      overflow-x: hidden;

      &.wrap__region {
        border-bottom: none;
        padding-top: 20px;
      }

      h2 {
        font-size: 11px;
        font-weight: normal;
      }

      ul {
        list-style: none;
        padding: 5px;
        margin: 0;

        li {
          font-size: 14px;
          color: #333;
          padding: 10px 0;
          transition: transform 200ms ease;
          transform-origin: left;

          &:hover {
            color: #666;
            transform: scale(1.2);
          }

          a {
            display: block;
          }
        }
      }
    }
    `;
  }

  get basicStyles() {
    return css`
    & {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
      height: 100%;  
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      margin: 0;
      padding: 0;
      z-index: -100;

      background-image: url(static/search-page-background.jpg);
      filter: brightness(60%) sepia(0.8);      
    }

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      background-image: url('data:image/svg+xml,<svg class="icon-mag-border" fill="rgb(255, 255, 255)" id="Capa_1" enable-background="new 0 0 515.558 515.558" height="512" viewBox="0 0 515.558 515.558" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m378.344 332.78c25.37-34.645 40.545-77.2 40.545-123.333 0-115.484-93.961-209.445-209.445-209.445s-209.444 93.961-209.444 209.445 93.961 209.445 209.445 209.445c46.133 0 88.692-15.177 123.337-40.547l137.212 137.212 45.564-45.564c0-.001-137.214-137.213-137.214-137.213zm-168.899 21.667c-79.958 0-145-65.042-145-145s65.042-145 145-145 145 65.042 145 145-65.043 145-145 145z"/></svg>');
      width: 38vw;;
      height: 38vw;
      z-index: -50;
      top: 10vh;
      right: -4vw;
      opacity: 0.2;
      background-size: 38vw;
      background-repeat: no-repeat;
      transition: all 300ms ease;
    }

    .no-result {
      font-size: 16px;
      padding: 20px;
      font-family: auto;
      color: #bcbcbc;
    }

    .search {
      position: relative;
      left: 50%;
      display: inline-block;
      transform: translate3d(-50%, 0, 0);
      color: #fff;
      margin-top: 18.9vh;
      width: 100%;
      text-align: center;
      font-size: 7.7vw;
      box-sizing: border-box;
      padding: 0 25vw;
      transition: all 300ms ease;

      flex: 0 0 30px;
      height: 30px;
    }

    .search::placeholder {
      color: rgba(255, 255, 255, 0.4);
      overflow: visible;
    }

    .search::-webkit-search-cancel-button {
      color: #fff;
      appearance: none;
      background: #fff;
    }

    .search-content {
      position: relative;
      height: 100%;
      width: 100%;
      flex: 1 1 auto;

      margin-top: 10vh;
      background-color: #fff;
      border-top-left-radius: 27px;
    }

    .search-content__top-bar {
      display: flex;
      flex-direction: row;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      padding-left: 25px;
      padding-right: 10px;
    }

    .top-bar__sort {
      display: flex;
      flex-direction: row;
    }

    .top-bar__search-result {
      font-size: 11px;
    }

    .sort-street-button,
    .sort-popular-button {
      font-size: 11px;
      border: none;
      background-color: transparent;
      outline: none;
      position: relative;
      color: #bcbcbc;
    }

    .sort-street-button.active,
    .sort-popular-button.active {
      color: #0b0b0b;
    }

    .sort-street-button.active::after,
    .sort-popular-button.active::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      left: 0;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #bea36b;
    }
    `;
  }
}

customElements.define('page-search', PageSearch);